import * as React from "react";
import {Fragment} from "react";
import BillCreatedNotification from "../../../model/notification/invoice/BillCreatedNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: BillCreatedNotification;
}

/**
 * Bill created notification toast body.
 */
const NotificationBillCreatedBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Bill {props.notification.data.jobRefNumber}</div>
			<div className={"toast-body"}>
				Bill has been created
			</div>
		</Fragment>
	);
};

export default NotificationBillCreatedBody;
